const timesheetCommonServicesName = "/UsedRest";

export function timesheetUsedRestService (http) {    
    return {
        getPersonnelUsedRest: (personnelCode, month, year) => {
            var param = {
                personnelCode,
                month,
                year
            }
            return http.post(timesheetCommonServicesName + "/GetPersonnelUsedRest", param);
        },
        getPersonnelUsedRestFromThisYearBeginning: (personnelCode, month, year) => {
            var param = {
                personnelCode,
                month,
                year
            }
            return http.post(timesheetCommonServicesName + "/GetPersonnelUsedRestFromThisYearBeginning", param);
        },
        getPersonnelUsedSickRestFromThisYearBeginning: (personnelCode, month, year) => {
            var param = {
                personnelCode,
                month,
                year
            }
            return http.post(timesheetCommonServicesName + "/GetPersonnelUsedSickRestFromThisYearBeginning", param);
        }           
    }
}